import './App.less';
import * as React from "react";
import "antd/dist/antd.css";
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  GraphQLRequest,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import { SignUp } from "./components/signup/SignUp";
import { SignIn } from "./components/signin/SignIn";
import { AuthProvider, ProtectedRoute } from "./components/auth/AuthContext";
import { UserProfile } from "./views/user-profile/UserProfile";
import { Home } from "./views/Home";
import { FourZeroFour } from "./views/FourZeroFour";
import {
  HomeOutlined,
  FileOutlined,
  FileTextOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { Layout, Menu, Breadcrumb } from "antd";
const httpLink = createHttpLink({
  uri: "https://alpha-weedist.hasura.app/v1/graphql",
});
const user_id = localStorage.getItem("user_id");

const authLink = setContext(
  ({ operationName }: GraphQLRequest, prevCtx: any) => {
    const publicOperations = ["signin", "signup"];
    if (
      operationName &&
      !publicOperations.includes(operationName.toLowerCase())
    ) {
      const token = localStorage.getItem("user_token");
      return {
        headers: {
          ...prevCtx.headers,
          Authorization: `Bearer ${token}`,
        },
      };
    }
  }
);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

const {Content, Footer, Header } = Layout;

class App extends React.Component {
  state = {
    collapsed: false,
  };

  onCollapse = (collapsed: Boolean) => {
    this.setState({ collapsed });
  };

  render() {
    const { collapsed } = this.state;
    return (
      <Router>
        <AuthProvider>
          <ApolloProvider client={client}>
            <Layout style={{ minHeight: "100vh" }}>
            <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
                  <div className="logo" />
                <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
                    {/* <Menu.Item key="3" icon={<HomeOutlined />}>
                      <Link to="/">Home</Link>
                    </Menu.Item> */}
                    <Menu.Item key="4" icon={<UserOutlined />} >
                      <Link to={"/profile/" + user_id}>Profile</Link>
                    </Menu.Item>
                    <Menu.Item key="5" icon={<FileTextOutlined />}>
                      <Link to="/signin">Sign In</Link>
                    </Menu.Item>
                  <Menu.Item key="9" icon={<FileOutlined />}>
                      <Link to="/signup">Sign Up</Link>
                  </Menu.Item>
                </Menu>
              </Header>
              <Layout className="site-layout">
                <Content style={{ margin: "70px 20px" }}>
                  <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>User</Breadcrumb.Item>
                    <Breadcrumb.Item>{user_id}</Breadcrumb.Item>
                  </Breadcrumb>
                  <Switch>
                    <Route exact path="/">
                      <Home />
                    </Route>
                    <Route path="/signup">
                      <SignUp />
                    </Route>
                    <Route path="/signin">
                      <SignIn />
                    </Route>
                    <ProtectedRoute path="/profile/:id">
                      <UserProfile />
                    </ProtectedRoute>
                    <Route>
                      <FourZeroFour />
                    </Route>
                  </Switch>
                </Content>
                <Footer style={{ textAlign: "center" }}>B5inc ©2021</Footer>
              </Layout>
            </Layout>
          </ApolloProvider>
        </AuthProvider>
      </Router>
    );
  }
}

export default App;
